
    const original = "<svg width=\"20px\" height=\"20px\" viewBox=\"0,0,20,20\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\">\n    <g stroke-linecap=\"round\" stroke=\"#855CD6\" fill=\"#855CD6\" fill-opacity=\"0.25\" stroke-width=\"4\" stroke-linejoin=\"miter\"><path d=\"M3,17 L10,3 L17,17\"/></g>\n</svg>";

    const getSRC = () => {
        const recolored = typeof Recolor === 'object' ? (
            original.replace(/#855cd6/gi, Recolor.primary)
        ) : original;
        return 'data:image/svg+xml;,' + encodeURIComponent(recolored);
    };

    export default getSRC;
